import { memo, Fragment, useState } from "react";

import classes from "./AddIngredientBar.module.css";

import VolumeForm from "../VolumeForm/VolumeForm";
import CustomButton from "../../General_Elements/CustomButton/CustomButton";


// component for each ingredient bar when adding ingredients to cabinet
const AddCabIngredientBar = (props) => {
  // if an ingredient is selected, open the form to choose the volume to add to cabinet
  const [showVolumeForm, setShowVolumeForm] = useState(false);

  const switchVolumeFormHandler = (ingredient) => {
    setShowVolumeForm(!showVolumeForm);
  };

  return (
    <Fragment>
      <div className={classes.cabinetIngredientBar}>
        {showVolumeForm ? (
          <Fragment>
            <VolumeForm ingredient={props.ingredient} switchVolumeFormHandler={switchVolumeFormHandler}/>
            <CustomButton onClick={switchVolumeFormHandler} content={">>"} type={"miscButton"} width="35px" height="35px"/>

          </Fragment>
        ) : (
          <Fragment>
            <div className={classes.title}>{props.ingredient.title}</div>
            <CustomButton onClick={switchVolumeFormHandler} content={"<<"} type={"miscButton"} width="35px" height="35px"/>
          </Fragment>
        )}
      </div>
    </Fragment>
  );
};

export default memo(AddCabIngredientBar);
